<app-svg-icon
    class="icon"
    [src]="src"
    [svgStyle]="{ 'width.px': style.width, 'height.px': style.height }"
></app-svg-icon>
